import { render, staticRenderFns } from "./TradeBox.vue?vue&type=template&id=2bdc3ec9&scoped=true&"
import script from "./TradeBox.vue?vue&type=script&lang=js&"
export * from "./TradeBox.vue?vue&type=script&lang=js&"
import style0 from "./TradeBox.vue?vue&type=style&index=0&id=2bdc3ec9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc3ec9",
  null
  
)

export default component.exports